<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="relative">
    <div class="vx-navbar-wrapper navbar-full p-0">
      <vs-navbar
        class="nv"
        :class="navbarClasses"
        :style="navbarStyle"
        :color="navbarColor"
      >
        <div slot="title">
          <router-link
            tag="div"
            to="/"
            class="vx-logo cursor-pointer mx-auto flex"
          >
            <span class="vx-logo-text">
              <img src="@/assets/images/1.png" width="85"
            /></span>
          </router-link>
        </div>

        <vs-navbar-item index="0">
          <router-link to="/" custom v-slot="{ navigate }">
            <a href="" style="font-size: 15px; color: #f0b104" @click="navigate"> Accueil</a>
            </router-link>
       
        </vs-navbar-item>
        <vs-navbar-item index="1">
          <div class=" vx-row dor">
            <router-link to="/home/sell" custom v-slot="{ navigate }">
              <a href="" style="font-size: 15px; color: #f0b104" @click="navigate">Je veux acheter</a>
            </router-link>
            <vs-dropdown>
              <h1>
                <feather-icon
                  icon="ChevronDownIcon"
                  svgClasses="w-4 h-4"
                  style="font-size: 15px; color: #f0b104"
                />
              </h1>
              <vs-dropdown-menu>
                <ul style="min-width: 9rem">
                  <router-link to="/home/rental">
                    <li
                      class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                    >
                      <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
                      <span class="ml-2">Je veux louer</span>
                    </li>
                  </router-link>
                </ul>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
          <!-- <vs-dropdown>
            <router-link to="/home/sell">
            <a
              
              style="font-size: 15px; color: #f0b104"
              >Je veux louer</a
            >
            </router-link>

            <vs-dropdown-menu>
              <ul style="min-width: 9rem">
                <router-link to="/home/sell">
                <li
                  class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                >
                  <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
                  <span class="ml-2">Je veux acheter</span>
                </li>
                 </router-link>
              </ul>
            </vs-dropdown-menu>
          </vs-dropdown> -->
        </vs-navbar-item>
        <vs-navbar-item index="2">
          <vs-dropdown>
            <a href="#" class="ml-2" style="font-size: 15px; color: #f0b104">
              Je suis Proprietaire</a
            >

            <vs-dropdown-menu class="vx-navbar-dropdown">
              <ul style="min-width: 9rem">
                <router-link to="/owner/house-rental/add">
                  <li
                    class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                  >
                    <feather-icon icon="CheckSquareIcon" svgClasses="w-4 h-4" />
                    <span class="ml-2">Mettre en location</span>
                  </li>
                </router-link>
                <router-link to="/owner/house-sale/add">
                  <li
                    class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                  >
                    <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
                    <span class="ml-2">Mettre en vente</span>
                  </li>
                </router-link>
              </ul>
            </vs-dropdown-menu>
          </vs-dropdown>
        </vs-navbar-item>

        <vs-navbar-item index="3">
          <vs-dropdown class="cursor-pointer logement">
            <a href="#" style="font-size: 15px; color: #f0b104">Logement</a>

            <vs-dropdown-menu class="vx-navbar-dropdown">
              <ul style="min-width: 9rem">
                <router-link to="/home/rental">
                  <li
                    class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                  >
                    <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
                    <span class="ml-2">Location</span>
                  </li>
                </router-link>
                <router-link to="/home/sell">
                  <li
                    class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                  >
                    <feather-icon icon="CheckSquareIcon" svgClasses="w-4 h-4" />
                    <span class="ml-2">Vente</span>
                  </li>
                </router-link>
              </ul>
            </vs-dropdown-menu>
          </vs-dropdown>
        </vs-navbar-item>

        <vs-navbar-item index="4" class="heartIcon" v-if="user">
          <router-link to="/wishlist">
            <p class="h2 mb-2">
              <b-icon icon="heart" aria-hidden="true" variant="danger"></b-icon>
            </p>
          </router-link>
        </vs-navbar-item>
        <notification-drop-down />
        <p v-if="user" class="text-white">
          Bienvenue <strong>{{user.username}}</strong>
        </p>
        <profile-drop-down />
      </vs-navbar>
    </div>
  </div>
</template>

<script>
import Bookmarks from './components/Bookmarks.vue'
import SearchBar from './components/SearchBar.vue'
import NotificationDropDown from './components/NotificationDropDown.vue'
import ProfileDropDown from './components/ProfileDropDown.vue'
import Logo from '../Logo.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'the-navbar-horizontal',
  props: {
    logo: { type: String },
    navbarType: {
      type: String,
      required: true
    }
  },
  components: {
    Logo,
    Bookmarks,
    SearchBar,
    NotificationDropDown,
    ProfileDropDown
  },
  data () {
    return {
  
    }
  },
  methods: {
    goToHome () {
      this.$router.push({name: 'home'})
    }
  },
  computed: {
    ...mapGetters({
      user:'user'
    }),
    navbarColor () {
      let color = '#000000'
      if (this.navbarType === 'sticky') color = '#f7f7f7'
      else if (this.navbarType === 'static') {
        if (this.scrollY < 50) {
          color = '#f7f7f7'
        }
      }

      if (this.isThemedark === 'dark') {
        if (color === '#fff') {
          color = '#10163a'
        } else {
          color = '#262c49'
        }
      }

      return color
    },
    isThemedark () {
      return this.$store.state.theme
    },
    navbarStyle () {
      return this.navbarType === 'static' ? { transition: 'all .25s ease-in-out' } : {}
    },
    navbarClasses () {
      return this.scrollY > 5 && this.navbarType === 'static' ? null : 'd-theme-dark-light-bg shadow-none'
    },
    scrollY () {
      return this.$store.state.scrollY
    },
    verticalNavMenuWidth () {
      return this.$store.state.verticalNavMenuWidth
    },
    windowWidth () {
      return this.$store.state.windowWidth
    }
  }
}
</script>

<style lang="css">
.nv {
  padding-left: 200px;
  padding-right: 100px;
}
.logement {
  margin-right: 30px;
}
.heartIcon {
  margin-right: 20px;
  color: #f0b104;
}
.heartIcon:hover {
  cursor: pointer;
}
.dor {
  min-width: 200px;
}
</style>